import store from 'store2'

const KEY = 'polleverywhere:previous_presenter_sessions'
const MAX_ITEMS = 6

function load () {
  try {
    return JSON.parse(store.get(KEY) || '[]')
  } catch (error) {
    return []
  }
}

function save (list) {
  this._cache = list
  return store.set(KEY, JSON.stringify(list))
}

function removeDuplicates (arr, entry) {
  let index
  if ((index = arr.lastIndexOf(entry)) > -1) {
    arr.splice(index, 1)
  }

  return arr
}

class RecentPresentations {
  mostRecent () {
    return this.list()[0]
  }

  list () {
    if (!this._cache) {
      this._cache = load()
    }
    return this._cache
  }

  add (presenter) {
    let list = this.list()
    if (list.length) {
      list = removeDuplicates(list, presenter)
    }

    list.unshift(presenter)
    const limited = list.slice(0, MAX_ITEMS)

    return save.call(this, limited)
  }

  remove (presenter) {
    const list = _.without(this.list(), presenter)

    return save.call(this, list)
  }

  _reset () {
    if (this._cache) {
      delete this._cache
    }
  }
}

export const recentPresentations = new RecentPresentations()
